import {Stack} from "@src/CommonComponents/Stack/Stack.tsx";
import styles from "./skeleton.module.less"
import {SkeletonType} from "@src/CommonComponents/SkeletonPlaceHolder/SkeletonType.ts";
import {SkeletonPlaceHolder} from "@src/CommonComponents/SkeletonPlaceHolder/SkeletonPlaceHolder.tsx";
import cn from "classnames";

export const CheckInOutSkeleton = () => {
    return (
        <Stack direction={"column"} gap={16}>
            <Stack justifyContent={"space-between"} className={styles.header} alignItems={"center"} >
                <Stack gap={16} className={styles.infoBlock} alignItems={"center"} >
                    <SkeletonPlaceHolder type={SkeletonType.text} height={10} width={120} />
                    <SkeletonPlaceHolder type={SkeletonType.rectangle} height={20} width={20} />
                    <SkeletonPlaceHolder type={SkeletonType.text} height={10} width={60} />
                </Stack>
                <Stack className={styles.button}>
                    <SkeletonPlaceHolder type={SkeletonType.rectangle} height={30} width={30} />
                </Stack>
            </Stack>
            <Stack direction={"column"} gap={16} className={styles.body}>
                <Stack className={styles.sub} direction={"column"} alignItems={"center"} gap={14} >
                    <SkeletonPlaceHolder type={SkeletonType.text} height={200} width={"100%"} />

                    <Stack direction={"column"} alignItems={"center"} gap={16} className={styles.greetings}>
                        <SkeletonPlaceHolder type={SkeletonType.text} height={10} width={"100%"}/>
                        <SkeletonPlaceHolder type={SkeletonType.text} height={10} width={"85%"}/>
                        <SkeletonPlaceHolder type={SkeletonType.text} height={10} width={"85%"}/>
                    </Stack>

                    <Stack className={styles.time} alignItems={"center"}>
                        <SkeletonPlaceHolder type={SkeletonType.rectangle} height={64} width={119} borderRadius={14} />
                    </Stack>

                    <SkeletonPlaceHolder type={SkeletonType.text} height={48} width={"100%"} borderRadius={14}/>
                </Stack>
                <Stack className={cn(styles.sub, styles.eventGroup)} direction={"row"} justifyContent={"flex-start"}>
                    <Stack alignItems={"center"} gap={16} className={styles.event}>
                        <SkeletonPlaceHolder type={SkeletonType.rectangle} height={24} width={24}/>
                        <Stack direction={"column"} gap={12}>
                            <SkeletonPlaceHolder type={SkeletonType.text} height={10} width={40}/>
                            <SkeletonPlaceHolder type={SkeletonType.text} height={10} width={40}/>
                        </Stack>
                    </Stack>
                    <Stack alignItems={"center"} gap={16} className={styles.event}>
                        <SkeletonPlaceHolder type={SkeletonType.rectangle} height={24} width={24}/>
                        <Stack direction={"column"} gap={12}>
                            <SkeletonPlaceHolder type={SkeletonType.text} height={10} width={40}/>
                            <SkeletonPlaceHolder type={SkeletonType.text} height={10} width={40}/>
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
        </Stack>

    )
}